// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-content--3pT0Q{padding:0 30px 50px 30px}\n", ""]);
// Exports
exports.locals = {
	"page-content": "page-content--3pT0Q"
};
module.exports = exports;
